export default "__VITE_ASSET__DNa4vRGx__"